/** 顶部固定导航：品牌链接、声音开关，以及菜单/贺卡关闭按钮。 */
import classNames from 'classnames';
import { useActiveLetterState } from '../../../atoms/active-letter';
import { useSoundConfigState } from '../../../atoms/sound-config';
import ChipsaLogoSVG from '../../../svg/logo';
import RoundButton from '../RoundButton';
import { useOpenedPopupsState } from '../../../atoms/opened-popups';

const Header = () => {
    // 三份共享状态分别控制声音样式、贺卡关闭按钮和菜单开合状态。
    const [soundConfig, setSoundConfig] = useSoundConfigState();
    const [activeLetterName] = useActiveLetterState();
    const [openedPopups] = useOpenedPopupsState();

    return (
        <header className="header wrapper pointer-events-none">
            <div className="header__left">
                <a
                    // Logo 指向 Chipsa 主站；target=_blank 避免离开当前 3D 体验。
                    href="https://chipsa.ru/"
                    target="_blank"
                    rel="noreferrer"
                    className="logo pointer-events-auto"
                    aria-label="Перейти на сайт Chipsa"
                >
                    <ChipsaLogoSVG />
                </a>
            </div>
            <div className="header__right">
                <RoundButton
                    aria-label="Звук"
                    className={classNames(
                        'header-btn sound-toggler-btn pointer-events-auto',
                        {
                            'sound-toggler-btn--enabled': soundConfig.enabled,
                        },
                    )}
                    // 保留 picked，只翻转 enabled；用户可随时静音/恢复声音。
                    onClick={() =>
                        setSoundConfig((prevConfig) => ({
                            ...prevConfig,
                            enabled: !prevConfig.enabled,
                        }))
                    }
                    data-sound="click"
                >
                    <svg
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect y="4" width="2" height="11" fill="#F2F2F2"></rect>
                        <rect x="4" width="2" height="15" fill="#F2F2F2"></rect>
                        <rect
                            x="8"
                            y="7"
                            width="2"
                            height="8"
                            fill="#F2F2F2"
                        ></rect>
                        <rect
                            x="12"
                            y="2"
                            width="2"
                            height="13"
                            fill="#F2F2F2"
                        ></rect>
                    </svg>
                </RoundButton>
                {/* 贺卡打开时，右上角按钮优先承担“关闭贺卡”的职责。 */}
                {activeLetterName ? (
                    <RoundButton
                        aria-label="Закрыть"
                        size="lg"
                        className={classNames(
                            'menu-btn header-btn pointer-events-auto',
                            {
                                'menu-btn--opened': activeLetterName,
                            },
                        )}
                        // lit-popup 通过 data 属性进行事件委托，不需要手写 click 回调。
                        data-lit-popup-close="letter"
                        data-sound="click"
                    >
                        <span></span>
                        <span></span>
                    </RoundButton>
                ) : (
                    <RoundButton
                        aria-label="Меню"
                        size="lg"
                        className={classNames(
                            'menu-btn header-btn pointer-events-auto',
                            {
                                'menu-btn--opened':
                                    openedPopups.includes('menu'),
                            },
                        )}
                        data-sound="click"
                        // 同一按钮根据全局弹窗状态动态成为 open 或 close 触发器。
                        data-lit-popup-open={
                            !openedPopups.includes('menu') ? 'menu' : undefined
                        }
                        data-lit-popup-close={
                            openedPopups.includes('menu') ? 'menu' : undefined
                        }
                    >
                        <span></span>
                        <span></span>
                    </RoundButton>
                )}
            </div>
        </header>
    );
};

export default Header;
